
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../controlador';
    import progreso from './resumen-progreso.vue';
    import mercadolibre from './resumen-mercadolibre.vue';
    import resumen from './resumen-resumen.vue';
    import barra from './resumen-barra.vue';
    import alertas from './resumen-alertas.vue';
    import otros from './resumen-otros-pedidos.vue';
    import observaciones from './resumen-observaciones.vue';
    import preguntas_ml from './resumen-preguntas-ml.vue';
    import chat_ml from './resumen-chat-ml.vue';
    import cliente from './resumen-cliente.vue';
    import contacto from './resumen-contacto.vue';
    import destino from './resumen-destino.vue';
    import transporte from './resumen-transporte.vue';
    import envio from './resumen-envio.vue';
    import items from './resumen-items.vue';
    import facturas from './resumen-facturas.vue';
    import pagos from './resumen-pagos.vue';
    import totales from './resumen-totales.vue';
    import archivos from './resumen-menu-archivos.vue';
    import estado from './resumen-menu-estado.vue';
    import resumen_estado from './resumen-estado.vue';
    //import ayuda from '../ayuda/ayuda.vue';
    import procesos from './resumen-menu-procesos.vue';
    import barralateral from './barra-lateral/barra-lateral.vue';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            barra,
            otros,
            progreso,
            alertas,
            resumen,
            cliente,
            envio,
            contacto,
            transporte,
            observaciones,
            preguntas_ml,
            chat_ml,
            destino,
            facturas,
            items,
            pagos,
            totales,
            archivos,
            procesos,
            estado,
            resumen_estado,
            //ayuda,
            mercadolibre,
            barralateral,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }
        public get Envio() { return this.Controlador.Pedido ? this.Controlador.Pedido.Envio : null; }
        public get Estado() { return this.Controlador.Vista.Estado; }
        public get ReservarEspacioDerecha() { return this.Controlador.Vista.BarraDerecha.Anchura.Espacio; }
        public Pedidos: Pedido[] = [];
        public AbiertoFacturar: boolean = false;
        public async Facturar()
        {
            this.AbiertoFacturar = false;
            this.Pedidos = [this.Pedido];
            if ( this.Pedidos.hasRows() )
            {
                this.$nextTick( () => this.AbiertoFacturar = true );

            } else
            {
                Utiles.Notificaciones.Alerta( '¡No hay pedidos que se puedan facturar!' );
            }


        }
    }
